"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hotelTypeMappping = void 0;
const hotelTypeMappping = (type) => {
    switch (type) {
        case "airport":
            return "Airport Hotel";
        case "all_inclusive":
            return "All Inclusive Hotel";
        case "all_suite_hotel":
            return "All Suite Hotel";
        case "apartment_hotel":
            return "Apartment Hotel";
        case "beachfront":
            return "Beachfront Hotel";
        case "boutique":
            return "Boutique Hotel";
        case "casino_hotel":
            return "Casino Hotel";
        case "city":
            return "City Hotel";
        case "golf_resort":
            return "Golf Resort";
        case "motel":
            return "Motel";
        case "resort_hotel":
            return "Resort Hotel";
        default:
            return "Hotel";
    }
};
exports.hotelTypeMappping = hotelTypeMappping;
